import {API_URL, apiPut} from '../api'
import {IUpdateFeedTemplate} from '../../pages/feed/types'

// PUT /v3/admin/feed_template/:id — 템플릿 문구(title/body/blocks) 교체. kind/language는 불변.
// 생성과 동일한 변수 계약으로 재검증되며, 위반/미존재 id는 code 5050으로 거부.
export const updateFeedTemplate = async (id: string, body: IUpdateFeedTemplate) => {
    return await apiPut(API_URL, `admin/feed_template/${id}`, body)
}
